import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration from environment variables
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Fallback to global variables if environment variables are not available
const config = window.__firebase_config || firebaseConfig;

// Initialize Firebase
const app = initializeApp(config);
const auth = getAuth(app);
const db = getFirestore(app);

// Enable offline persistence for Firestore
try {
    // Only enable offline persistence if it hasn't been enabled already
    if (typeof window !== 'undefined' && !window.firestoreInitialized) {
        window.firestoreInitialized = true;
    }
} catch (error) {
    console.warn('Firestore offline persistence already enabled or not supported:', error);
}

export { app, auth, db };
